import * as React from "react";
import { Link } from "gatsby";
import { PAGES } from "../shared/constants";
import { useMediaQuery } from "react-responsive";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { HamburgerMenuIcon } from "@radix-ui/react-icons"


const navItems = [
  { link: "/" + PAGES.PUBLICATIONS, label: "Publications" },
  { link: "/laziz_cv.pdf", label: "CV", external: true },
];

const Navigation = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  
  return (
    <section className="global-nav">
      <div className="container">
        <h1 className="main-heading">
          <Link to="/">
            Laziz Abdullaev
          </Link>
        </h1>

        {!isMobile && (
          <nav>
            {navItems.map(item => (
              <div className="nav-item-container" key={item.link}>
                {item.external ? (
                  <a href={item.link} target="_blank" rel="noopener noreferrer" className="nav-link">
                    <span>{item.label}</span>
                  </a>
                ) : (
                  <Link to={item.link} activeClassName="active-nav-link" className="nav-link">
                    <span>{item.label}</span>
                  </Link>
                )}
              </div>
            ))}
          </nav>
        )}
        {isMobile && (
          <div>
            <DropdownMenu.Root>
              <DropdownMenu.Trigger asChild>
                <button className="nav-link" style={{background:"none",border:"none",cursor:"pointer",padding:0}}><HamburgerMenuIcon/></button>
              </DropdownMenu.Trigger>

              <DropdownMenu.Content sideOffset={8} className="dropdown-menu">
                {navItems.map(item => (
                  <DropdownMenu.Item key={item.label} className="dropdown-item">
                    {item.external ? (
                      <a href={item.link} target="_blank" rel="noopener noreferrer" className="dropdown-button">
                        <span>{item.label}</span>
                      </a>
                    ) : (
                      <Link to={item.link} className="dropdown-button">
                        <span>{item.label}</span>
                      </Link>
                    )}
                  </DropdownMenu.Item>
                ))}
              </DropdownMenu.Content>
            </DropdownMenu.Root>
          </div>
        )}
      </div>
    </section>
  );
};

export default Navigation;
